import { values } from 'lodash'
import PropTypes from 'prop-types'

import { idPropType } from '../../common/prop-types'

import { INGREDIENT_PHRASE_TYPES } from '../constants'

const ingredientPhrasePropType = PropTypes.shape({
  id: idPropType.isRequired,
  phrase: PropTypes.string.isRequired,
  type: PropTypes.oneOf(values(INGREDIENT_PHRASE_TYPES)),
})

export default ingredientPhrasePropType
